import { Injectable } from '@angular/core';
import { DataService } from './data.service'; //
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SponsorService {

  constructor(private data: DataService) { }

  add(payload: any, message?: string): Observable<any> {
    return this.data.post('sponsor/add', payload, message);
  }

  updateOrder(payload: any, message?: string): Observable<any> {
    return this.data.post('sponsor/order', payload, message);
  }

  delete(id: number, message?: string): Observable<any> {
    return this.data.delete(`sponsor?id=${id}`, message);
  }
}
